export default "__VITE_ASSET__DBVaE2Wr__"